if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: false,
      numberFilterTree: 2,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true,
      paginationTypeAdvanced: false,
      activeLoadPreviousPage: false,
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    var firstAvailableVariant = data.variants.filter(function(e) {
      return e.available;
    });
    var firstVariant = typeof firstAvailableVariant[0] !== 'undefined' ? firstAvailableVariant[0] : data['variants'][0];

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    
    // Images Column
    var itemImagesHtml = '';
    if (boostPFSThemeConfig.custom.show_prd_image == 'yes') {
      itemImagesHtml += '<td class="table-body-cell pro-imgcell cws_prd_img">';
      itemImagesHtml += '<div class="list-view-item__image-column product-img">';
      itemImagesHtml += '<div class="product-label">';
      itemImagesHtml += buildLabels(data);
      itemImagesHtml += '</div>';
      itemImagesHtml += '<a href="{{itemUrl}}" class="list-view-item">';
      if (images.length > 0) {
        itemImagesHtml += '<div class="reveal">';
        itemImagesHtml += '<img class="list-view-item__image" src="' + Utils.getFeaturedImage(images, '90x90') + '" alt="{{itemTitle}}">';
        itemImagesHtml += '<div class="hidden">';
        itemImagesHtml += '<div class="caption">';
        if (images.length > 1) {
          itemImagesHtml += '<div class="centered"><img class="hidden" src="' + Utils.optimizeImage(images[1]['src'], '90x90') + '" alt="{{itemTitle}}" /></div>';
        }
        itemImagesHtml += '</div>';
        itemImagesHtml += '</div>';
        itemImagesHtml += '</div>';
      }
      itemImagesHtml += '</a>';
      itemImagesHtml += '</div>';
      itemImagesHtml += '</td>';
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
    
    // Brands Column
//     var itemBrandsHtml = '';
//     if (boostPFSThemeConfig.custom.show_prd_image == 'yes') {
//       itemBrandsHtml += '<td class="table-body-cell product-vendor cws_brand_sku">';
//       if (data.vendor !== '') {
//         itemBrandsHtml += '<p><b>' + boostPFSThemeConfig.label.brand_text + ':</b> ' + data.vendor + '</p>';
//       }
//       if (firstVariant.sku !== '') {
//         itemBrandsHtml += '<p><b>' + boostPFSThemeConfig.label.sku_text + ':</b> ' + firstVariant.sku + '</p>';
//       }
//       itemBrandsHtml += '</td>';
//     }
//     itemHtml = itemHtml.replace(/{{itemBrands}}/g, itemBrandsHtml);
    
    // Prices Column
//     var itemPricesHtml = '';
//     if (priceVaries) {
//       itemPricesHtml += '<p>';
//       itemPricesHtml += '<span class="product-price__price">' + boostPFSThemeConfig.label.from + ' </span>';
//       itemPricesHtml += '<span class="money min_price">' + Utils.formatMoney(data.price_min) + '</span>';
//       itemPricesHtml += '</p>';
//     } else {
//       itemPricesHtml += '<p>';
//       itemPricesHtml += '<span class="product-price__price single-price money"><b>' + Utils.formatMoney(data.price_min) + '</b></span>';
//       itemPricesHtml += '</p>';
//       if (data.variants.length == 1 && firstVariant.title == 'Default title') {
//         if (firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price) {
//           itemPricesHtml += '<p>';
//           itemPricesHtml += '<span class="money compare_price" style="text-decoration:line-through;"><b>' + Utils.formatMoney(data.compare_at_price_min) + '</b></span>';
//           itemPricesHtml += '</p>';
//           itemPricesHtml += '<p>';
//           itemPricesHtml += '<span class="label savings">' + boostPFSThemeConfig.label.save + ' ' + data.percent_sale_min + '%</span>';
//           itemPricesHtml += '</p>';
//         }
//       }
//     }
//     itemHtml = itemHtml.replace(/{{itemPrices}}/g, itemPricesHtml);
    
    // Stock Html
    var itemStockHtml = '';
    var max = '';
    if (firstVariant.inventory_management == 'shopify' && firstVariant.inventory_policy != 'continue') {
      if (firstVariant.inventory_quantity < 1) {
        max = 0;
      } else {
        max = firstVariant.inventory_quantity;
        itemStockHtml = boostPFSThemeConfig.label.in_stock_text + ': ' + max;
      }
    }
    itemHtml = itemHtml.replace(/{{itemQty}}/g, boostPFSThemeConfig.custom.preset_qty_val);
    itemHtml = itemHtml.replace(/{{itemQtyMax}}/g, max);
    itemHtml = itemHtml.replace(/{{itemStockHtml}}/g, itemStockHtml);
    
    // Add Custom class/text
    itemHtml = itemHtml.replace(/{{itemCartDescription}}/g, boostPFSThemeConfig.label.cart_description);
    itemHtml = itemHtml.replace(/{{itemAddToCartText}}/g, boostPFSThemeConfig.label.single_add_to_cart_button_text);
    
    // Metafield
    var itemStateHtml = '';
    var itemCarrierHtml = '';
    if (Utils.getProductMetafield(data, 'my_fields', 'state') !== null) {
      itemStateHtml = Utils.getProductMetafield(data, 'my_fields', 'state');
      itemStateHtml = itemStateHtml.replace('[', '').replace(']', '').replace(/"/g, '');
    }
    if (Utils.getProductMetafield(data, 'my_fields', 'carrier') !== null) {
      itemCarrierHtml = Utils.getProductMetafield(data, 'my_fields', 'carrier');
    }
    itemHtml = itemHtml.replace(/{{itemState}}/g, itemStateHtml);
    itemHtml = itemHtml.replace(/{{itemCarrier}}/g, itemCarrierHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{variantId}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildLabels(data) {
    var html = '';
    
    var date_created = new Date(data.created_at);
    date_created = date_published.getTime() / 1000;
    var date_now = new Date();
    date_now = date_now.getTime() / 1000;
    var date_difference = (date_now - date_created) / 86400;
    
    if (boostPFSThemeConfig.custom.show_lbl_val == 'yes') {
      if (onSale) {
        html += '<span class="badge-sale">' + boostPFSThemeConfig.label.sale_label + '</span>'; 
      } else if (date_difference < boostPFSThemeConfig.custom.new_label_days && !soldOut) {
        html += '<span class="badge-new">' + boostPFSThemeConfig.label.new_label + '</span>'; 
      }
      if (soldOut) {
        html += '<span class="badge-soldout">' + boostPFSThemeConfig.label.soldout_label + '</span>';
      }
    }
    
    return html;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if(paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
  }

  // Build Additional Elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
  };

  /************************** END BUILD TOOLBAR **************************/
  
  FilterOptionItemList.prototype.compileTemplate = function() {
    var label = this.label;

    if (this.parent.filterOptionId == 'pf_m_::my_fields::state') {
      label = label.replace('[', '').replace(']', '').replace(/"/g, '')
    }
    
    return this.getTemplate()
                .replace(/{{class.filterOptionItem}}/g, Class.filterOptionItem)
                .replace(/{{class.filterOptionLabel}}/g, Class.filterOptionLabel)
                .replace(/{{class.button}}/g, Class.button)
                .replace(/{{disabled}}/g, this.isDisabled() ? 'disabled' : '')
                .replace(/{{label}}/g, Utils.stripHtml(label))
                .replace(/{{href}}/g, this.href)
                .replace(/{{countLabel}}/g, Utils.stripHtml(this.countLabel));
  }
  FilterRefineByItem.prototype.buildLabel = function() {
    var formatLabel = this.filterItemId;

    if (this.filterOption) {
      switch (this.filterOption.displayType) {
        case FilterOptionEnum.DisplayType.RANGE:
          formatLabel = this.buildLabelRange();
          break;
        case FilterOptionEnum.DisplayType.RATING:
          formatLabel = this.buildLabelRating();
          break;
        case FilterOptionEnum.DisplayType.MULTI_LEVEL_COLLECTIONS:
        case FilterOptionEnum.DisplayType.MULTI_LEVEL_TAG:
          formatLabel = this.buildLabelMultiLevel();
          break;
        default:
          if (this.filterItem) {
            var label = this.filterItem.label;
            if (this.filterOptionId == 'pf_m_::my_fields::state') {
              label = label.replace('[', '').replace(']', '').replace(/"/g, '')
            }
            formatLabel = Utils.stripHtml(label);
          } else {
            // Fix issue when user filter by a value but the value doesn't exist in filter tree
            var dummyFilterItem = new FilterOptionItem(this.filterOption.filterTreeType);
            dummyFilterItem.filterOption = this.filterOption;
            dummyFilterItem.label = Utils.stripHtml(this.filterItemId);
            formatLabel = Utils.stripHtml(dummyFilterItem.buildLabel());
          }
          break;
      }
    }

    return Utils.stripHtml(formatLabel);
  }
})();
